import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalBody,
    Text,
    Box,
    Flex,
    ModalContent,
    ModalFooter,
} from '@chakra-ui/react';
import ZaraButton from '../custom-components/buttons/Button';

const UnCancelSubscriptionModal = ({ isOpen, onClose, onConfirm }) => (
    <Modal isCentered isOpen={isOpen} onClose={onClose} motionPreset='slideInBottom'>
        <ModalOverlay />
        <ModalContent minW='448px'>
            <ModalHeader fontSize='18px' lineHeight='28px' fontWeight='700' textAlign='left'>
                Confirm un-canceling subscription
            </ModalHeader>
            <ModalBody>
                <Box color='#2D3748' textAlign='left'>
                    <Text fontSize='16px' lineHeight='24px' fontWeight='400'>
                        Are you sure you want to reactivate your subscription?
                    </Text>
                    <Text>Your subscription will be automatically renewed.</Text>
                </Box>
            </ModalBody>
            <ModalFooter p='16px 24px'>
                <Flex alignItems='center' justifyContent='flex-end' w='100%'>
                    <ZaraButton w='60px' onClick={onClose} mr='12px' variant='secondary'>
                        No
                    </ZaraButton>
                    <ZaraButton w='60px' onClick={onConfirm}>
                        Yes
                    </ZaraButton>
                </Flex>
            </ModalFooter>
        </ModalContent>
    </Modal>
);

export default UnCancelSubscriptionModal;
